export const FUNNEL_MODE = {
    DEFAULT: 'DEFAULT',
    CUSTOM: 'CUSTOM',
};
